import { RenderablePool } from "../renderables/RenderablePool";
import { MaterialPool } from "./MaterialPool";
/**
 * @class away.pool.MaterialGroupBase
 */
var MaterialGroupBase = (function () {
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function MaterialGroupBase(stage, abstractionClassPool) {
        this._abstractionClassPool = new Object();
        this._materialPools = new Object();
        this._renderablePools = new Object();
        this._stage = stage;
        this._abstractionClassPool = abstractionClassPool;
    }
    Object.defineProperty(MaterialGroupBase.prototype, "stage", {
        get: function () {
            return this._stage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MaterialGroupBase.prototype, "abstractionClassPool", {
        get: function () {
            return this._abstractionClassPool;
        },
        enumerable: true,
        configurable: true
    });
    MaterialGroupBase.prototype.getMaterialPool = function (elements) {
        return this._materialPools[elements.elementsType] || (this._materialPools[elements.elementsType] = new MaterialPool(elements.elementsClass, this));
    };
    MaterialGroupBase.prototype.getRenderablePool = function (entity) {
        return this._renderablePools[entity.id] || (this._renderablePools[entity.id] = new RenderablePool(entity, this));
    };
    return MaterialGroupBase;
}());
export { MaterialGroupBase };



// WEBPACK FOOTER //
// ../dist/lib/materials/MaterialGroupBase.js